import { Button, Label, ListBox, Select } from '@heroui/react';
import { CalendarPlus, Download, Upload } from 'lucide-react';
import { VisitsTable } from '@/components/organisms/VisitsTable';
import { ImportVisitsModal } from './components/ImportVisitsModal';
import { CreateVisitModal } from './components/CreateVisitModal';
import { useVisitsPage } from './useVisitsPage';
import { PageContainer } from '@/components/templates/PageContainer';

export function VisitsPage() {
  const {
    statusOptions,
    selectValue,
    handleStatusChange,
    error,
    isImportOpen,
    importResult,
    isImporting,
    handleOpenImport,
    handleCloseImport,
    handleDownloadSample,
    handleImport,
    isCreateOpen,
    templates,
    workers,
    locations,
    fetchLocationsForTemplate,
    isCreating,
    createError,
    handleOpenCreate,
    handleCloseCreate,
    handleCreateVisit,
  } = useVisitsPage();

  return (
    <PageContainer>
      <div className="mb-4 flex flex-wrap items-center justify-between gap-4">
        <h2 className="text-2xl font-bold text-foreground">Визиты</h2>
        {/* items-end: у Select сверху лейбл «Статус», кнопки выравниваем по триггеру */}
        <div className="flex flex-wrap items-end gap-2">
          <Select className="w-56" value={selectValue} onChange={(key) => handleStatusChange(key)}>
            <Label>Статус</Label>
            <Select.Trigger>
              <Select.Value />
              <Select.Indicator />
            </Select.Trigger>
            <Select.Popover>
              <ListBox>
                {statusOptions.map((opt) => (
                  <ListBox.Item key={opt.id} id={opt.id} textValue={opt.label}>
                    {opt.label}
                    <ListBox.ItemIndicator />
                  </ListBox.Item>
                ))}
              </ListBox>
            </Select.Popover>
          </Select>
          <Button onPress={handleOpenCreate}>
            <CalendarPlus className="size-4" />
            Создать визит
          </Button>
          <Button variant="outline" onPress={() => void handleDownloadSample()}>
            <Download className="size-4" />
            Скачать пример
          </Button>
          <Button variant="outline" onPress={handleOpenImport}>
            <Upload className="size-4" />
            Импортировать
          </Button>
        </div>
      </div>

      {error && (
        <p className="mb-3 rounded-[var(--radius)] bg-danger px-3 py-2 text-sm text-danger-foreground">
          {error}
        </p>
      )}

      <VisitsTable />

      <ImportVisitsModal
        isOpen={isImportOpen}
        onClose={handleCloseImport}
        isImporting={isImporting}
        importResult={importResult}
        onImport={(file) => void handleImport(file)}
      />

      <CreateVisitModal
        isOpen={isCreateOpen}
        onClose={handleCloseCreate}
        templates={templates}
        workers={workers}
        locations={locations}
        onTemplateChange={(id) => void fetchLocationsForTemplate(id)}
        isCreating={isCreating}
        error={createError}
        onCreate={handleCreateVisit}
      />
    </PageContainer>
  );
}
